<template>
    <MediationManagementLayout v-if="isReady()"
            :test-group="testGroupComputed"
            :country-code="countryCodeComputed"
            :app-key="appKeyComputed"
            :group-id="groupIdComputed"
            :group-name="groupNameComputed"
            :country-name="countryNameComputed"
            :adUnit="adUnit"
            :disableChangeTier="disableChangeTierComputed"
            :showSegmentTooltip="showSegmentTooltipComputed"
            :groupHasChina="groupHasChinaComputed"
            :hasAb="hasAbComputed"
            @menuAction="emitMenuAction"
            @handleError="handleError"
            @rateChanged="rateChanged"
            @csvMenuItemClick="emitCsvMenuItemClick"
    >
    </MediationManagementLayout>
</template>

<script>
import MediationManagementLayout from 'monetize/mediationManagement/MediationManagementLayout.vue';
import externalPropsParser from 'services/utils/externalPropsParser';
import externalParsedProps from '../mixins/externalParsedProps';
import eventBus from '../mixins/eventBus';

const parsedProps = ['groupId', 'testGroup', 'appKey', 'countryCode', 'groupName', 'countryName', 'disableChangeTier',
    'showSegmentTooltip', 'groupHasChina', 'hasAb'];
const mandatoryProps = ['groupId', 'testGroup', 'appKey', 'groupName'];

export default {
    name: 'MediationManagementLayoutEx',
    components: { MediationManagementLayout },
    mixins: [
        eventBus('mediation-management-layout-ex'),
        externalParsedProps(MediationManagementLayout.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(MediationManagementLayout.props, parsedProps),
    methods: {
        isReady() {
            return mandatoryProps.every((prop) => !!this[`${prop}Computed`]);
        },
        handleError(data) {
            this.$emit('handleError', data);
        },
        emitMenuAction(data) {
            this.$emit('menuAction', data);
        },
        rateChanged(data) {
            this.$emit('rateChanged', data);
        },
        emitCsvMenuItemClick(data) {
            this.$emit('csvMenuItemClick', data);
        }
    },
    created() {
        const eventName = 'getData';
        this.$on(eventName, () => {
            this.$children.forEach((childComponent) => {
                childComponent.$emit(eventName);
            });
        });
    }
};
</script>

<style scoped>

</style>
